<template>
  <div class="card-item">
    <div class="card-item-image">
      <img :src="value.card_pic">
    </div>
    <div class="card-item-content">
      <div class="card-name">{{ value.card_name }}</div>
      <div class="flex-box">
        <div class="flex-item">
          <div>兑换时间: {{ value.create_time }}</div>
          <div v-if="value.state === 1">有效期: {{ expirationDate }} 个月</div>
          <div v-else>使用时间: {{ value.use_time }}</div>
        </div>
        <van-button class="check-btn" color="#F5DCAD" @click="toDetail">查看</van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    expirationDate () {
      const date = new Date(this.value.exp_time)
      const now = new Date()
      const expiraMonth = date.getMonth() + 1
      const nowMonth = now.getMonth() + 1
      // 剩余多少个月
      const surplus = expiraMonth - nowMonth
      return surplus ? surplus : 0
    }
  },
  methods: {
    toDetail () {
      this.$router.push({
        path: '/coupon-detail',
        query: {
          c_id: this.value.id
        }
      })
    }
  }
}
</script>
<style scoped>
  .card-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.1rem;
    background: #f1f1f1;
    border-radius: 5px;
    margin-bottom: 10px;
    width: 3.34rem;
    margin: 0.1rem auto;
    border: 2px solid #F5DCAD;
  }
  .card-item-image{
   width: 0.6rem;
   height: 0.6rem;
   border-radius: 5px;
  }
  .card-item-image img {
    border-radius: 5px;
  }

  .card-item-content{
    width: calc(100% - 0.78rem);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 0.78rem;
    text-align: left;
  }

  .flex-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flex-item{
    color: #999999;

  }

  .check-btn{
    width: 0.56rem;
    height: 0.31rem;
    color: #000 !important;
    padding: 0;
  }

  .card-name{
    font-size:0.15rem ;
    font-weight: 800;
  }

</style>